import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import UniversalMfaDashboard from '../../modules/universalMFA/UniversalMFADashboard';
import { UniversalMfaBlockPage, useUniversalMfaEnabled } from '../../modules/universalMFA';

export const UniversalMFADashboardRouting = (props: LogicalRouteImportProps) => {
    const enabledByPricingModules = useUniversalMfaEnabled();

    return (
        <LogicalRoute
            {...props}
            component={UniversalMfaDashboard}
            blockPageComponent={UniversalMfaBlockPage}
            displayBlockPage={!enabledByPricingModules}
        />
    );
};
